import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Any, Mapped } from "@/__main__/data-model.mjs";

export const Timeline = {
  frameInterval: Number,
  gameId: Number,
  frames: [
    {
      events: [Any],
      participantFrames: Mapped({
        key: String,
        value: {
          currentGold: Number,
          goldPerSecond: Number,
          jungleMinionsKilled: Number,
          level: Number,
          minionsKilled: Number,
          participantId: Number,
          timeEnemySpentControlled: Number,
          totalGold: Number,
          xp: Number,
          championStats: {
            abilityHaste: Number,
            abilityPower: Number,
            armor: Number,
            armorPen: Number,
            armorPenPercent: Number,
            attackDamage: Number,
            attackSpeed: Number,
            bonusArmorPenPercent: Number,
            bonusMagicPenPercent: Number,
            ccReduction: Number,
            cooldownReduction: Number,
            health: Number,
            healthMax: Number,
            healthRegen: Number,
            lifesteal: Number,
            magicPen: Number,
            magicPenPercent: Number,
            magicResist: Number,
            movementSpeed: Number,
            omnivamp: Number,
            physicalVamp: Number,
            power: Number,
            powerMax: Number,
            powerRegen: Number,
            spellVamp: Number,
          },
          position: {
            x: Number,
            y: Number,
          },
          damageStats: {
            magicDamageDone: Number,
            magicDamageDoneToChampions: Number,
            magicDamageTaken: Number,
            physicalDamageDone: Number,
            physicalDamageDoneToChampions: Number,
            physicalDamageTaken: Number,
            totalDamageDone: Number,
            totalDamageDoneToChampions: Number,
            totalDamageTaken: Number,
            trueDamageDone: Number,
            trueDamageDoneToChampions: Number,
            trueDamageTaken: Number,
          },
        },
      }),
      timestamp: Number,
    },
  ],
  participants: [
    {
      participantId: Number,
      puuid: String,
    },
  ],
} satisfies ModelDefinition;

const TimelineModel = createModel({
  data: {
    timeline: {
      info: Timeline,
    },
  },
}).transform(Timeline, (data) => {
  return data.data.timeline.info;
});

export type MatchTimeline = FromModel<typeof TimelineModel>;
export default TimelineModel;
